var React = require('react');

function XIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1924","data-name":"Group 1924","transform":"translate(9.154 -6.325) rotate(45)"},[React.createElement("path",{"id":"Path_1785","data-name":"Path 1785","d":"M0,0V21.891","transform":"translate(10.945 0)","fill":"none","stroke":"#18404b","strokeLinecap":"round","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_1786","data-name":"Path 1786","d":"M0,0V21.89","transform":"translate(21.89 10.945) rotate(90)","fill":"none","stroke":"#18404b","strokeLinecap":"round","strokeWidth":"2","key":1})]));
}

XIcon.defaultProps = {"width":"18.308","height":"18.308","viewBox":"0 0 18.308 18.308"};

module.exports = XIcon;

XIcon.default = XIcon;
